<template>
  <div id="main">
    <div :class="['main-content__menus', showMenus? 'main-content__menus--open':'']">
      <SiteMenus :show="showMenus" />
    </div>
    <div class="ipub-common-content main-content">
      <div style="width:calc(100% - 65px)">
        <site-header />
        <div :class="['main-content__section', showMenus? '':'main-content__section--open']">
          <!-- <ipub-breadcrumb class="mar-b-10"
                           :menus="menus" /> -->
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </div>
    </div>
    <ipub-loading :loading="loading" />
    <site-footer :copyright="publisherInfo.copyright" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
